<template>
	<div class="webview-editor">
		<table>
			<tbody>
				<register-row title="화면명">
					<input aria-label="화면명" v-model="title" type="text" />
				</register-row>
				<register-row v-if="mode === 'modify'" title="URL">
					<p class="webview-editor__url">
						{{ url }}
						<button
							class="btn webview-editor__url__copy"
							v-clipboard:copy="url"
						>
							복사
						</button>
					</p>
				</register-row>
				<register-row title="내용">
					<label>
						<editor
							ref="webviewEditor"
							v-model="context"
							:api-key="$store.state.env.TINYMCE_API_KEY"
							:init="editorPlugins"
						/>
						<input
							id="multipleFileUploader"
							type="file"
							style="display: none"
							@change="editorFileUploader($event.target.files)"
							multiple
						/>
					</label>
				</register-row>
			</tbody>
		</table>
		<div class="btn-wrap-main">
			<button @click="onSubmit" class="btn-main blue">
				{{ mode === 'register' ? '등록' : '수정' }}
			</button>
			<button @click="toList" class="btn-main bordered">취소</button>
		</div>
	</div>
</template>
<script>
	import RegisterRow from '@/components/event/RegisterRow';
	import Editor from '@tinymce/tinymce-vue';

	export default {
		name: 'WebviewEditor',
		components: {
			RegisterRow,
			Editor,
		},
		props: {
			mode: {
				type: String,
				default: 'register',
				validator(value) {
					return ['register', 'modify'].indexOf(value) !== -1;
				},
			},
		},
		data() {
			const baseUrl =
				process.env.NODE_ENV === 'development'
					? 'https://static.glowpick.net/webview'
					: 'https://static.glowpick.com/webview';

			return {
				baseUrl,
				title: '',
				context: '',
				url: '',
				editorPlugins: {
					plugins: [
						'advlist autolink link image lists charmap print preview hr anchor pagebreak',
						'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
						'save table directionality emoticons template paste',
					],
					toolbar:
						'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | fontsizeselect link image',
					file_picker_types: 'file image media',
					image_description: true,
					image_dimensions: false,
					height: 772,
					file_picker_callback(callback, value, meta) {
						if (meta.filetype === 'image') {
							document
								.getElementById('multipleFileUploader')
								.click();
						}
					},
				},
			};
		},
		mounted() {
			if (this.mode === 'modify') {
				const id = this.$route.params.webviewId;

				if (!id) {
					this.toList();
				}

				this.getData(id);
			}
		},
		methods: {
			getData(id) {
				this.$axiosAdmin2
					.get(`/api/webview/${id}`)
					.then(({ data }) => {
						this.title = data.title;
						this.context = data.viewDesc;
						this.url = `${this.baseUrl}/webviewTemplate.html?id=${id}`;
					})
					.catch(({ response }) => {
						console.error(response);
					});
			},
			editorFileUploader(fileList) {
				const imageBaseUrl = 'https://d9vmi5fxk1gsw.cloudfront.net';
				let files;

				if (typeof fileList === 'object') {
					files = Array.from(fileList);
				} else {
					files = fileList;
				}

				if (files.length === 0) {
					return false;
				}

				const image = files.shift();
				const reader = new FileReader();

				reader.readAsDataURL(image);

				reader.onload = event => {
					this.$axiosAdmin2
						.post('/api/common/image', {
							data: event.target.result,
							extension: image.type.split('/').pop(),
							fileName: image.name,
							target: 'event',
						})
						.then(({ data }) => {
							this.$refs.webviewEditor.editor.editorManager.execCommand(
								'mceInsertContent',
								false,
								`<img src="${imageBaseUrl}${data.data.fileDir}/${data.data.fileSaveName}" style="width:100%;display:block" alt="" />`
							);

							this.editorFileUploader(files);
						})
						.catch(err => {
							console.error(err);
							alert('파일업로드에 실패 했습니다.');

							this.$store.commit('toggleSpinner', false);
						});
				};
			},
			onSubmit() {
				if (this.title.trim().length === 0) {
					alert('화면명을 입력해 주세요');
					return false;
				} else if (this.context.trim().length === 0) {
					alert('내용을 입력해 주세요');
					return false;
				}

				const params = {
					title: this.title,
					viewDesc: this.context,
				};

				if (this.mode === 'modify') {
					params.id = this.$route.params.webviewId;
				}

				this.$axiosAdmin2
					.post('/api/webview/save', params)
					.then(({ data }) => {
						const message = `${this.mode === 'register' ? '등록' : '수정'} 되었습니다.`;

						alert(message);
						this.toList();
					})
					.catch(({ response }) => {
						console.error(response);
					});
			},
			toList() {
				this.$router.push('/operation/webview/list');
			},
		},
	};
</script>
<style lang="scss" scoped>
	.webview-editor__url {
		text-align: center;
	}

	.webview-editor__url__copy {
		display: inline-block;
		margin-left: 1em;
		vertical-align: middle;
	}
</style>
